import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { LoginLayout } from '@/components/modules/Layout/LoginLayout';
import { PasswordResetEditForm } from '@/components/modules/pages/password/PasswordResetEditForm';
import { loginPath } from '@/utils/router/links';
export const PASSWORD_RESET_EDIT_REQUEST_TYPE_SETTING = 'setting';
export const PASSWORD_RESET_EDIT_REQUEST_TYPE_RESET = 'reset';
/**
 * パスワード再設定（view）
 */
export const PasswordResetEditView = (props) => {
    const { className = '', customErrorCallback, onSubmit, requestType } = props;
    return (_jsx(LoginLayout, Object.assign({ bottomText: _jsx(RouterLink, Object.assign({ className: 'text-current underline', to: loginPath() }, { children: "\u30ED\u30B0\u30A4\u30F3\u3078\u623B\u308B" })), className: className, title: requestType === PASSWORD_RESET_EDIT_REQUEST_TYPE_RESET
            ? 'パスワード再設定'
            : 'パスワード初期設定' }, { children: _jsx(PasswordResetEditForm, { className: 'p-32', customErrorCallback: customErrorCallback, onSubmit: onSubmit }) })));
};
